<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">Statement Receipt</span>
        </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="invoiceGeneration">
            <div class="row">
                <div class="col-xl-12">
                    <div class="row d-flex justify-content-center">
                        <div class="col-xl-4 mt-3">
                            <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                <mat-label>From Date</mat-label>
                                <input readonly matInput [matDatepicker]="startDate" formControlName="startDate"
                                    selectable="isSelectable(date,type)" id="startDate" autocomplete="off"
                                    placeholder="Select From Date" class="custom-input-border" specialIsAlphaNumeric
                                    (click)="openStartDateDatePicker()">
                                <mat-datepicker-toggle matSuffix [for]="startDate" style="color:black;">
                                    <button mat-icon-button>
                                        <mat-icon>event</mat-icon>
                                    </button>
                                </mat-datepicker-toggle>
                                <mat-datepicker #startDate></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col-xl-4 mt-3">
                            <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                <mat-label>To Date</mat-label>
                                <input readonly matInput [matDatepicker]="endDate" formControlName="endDate"
                                    selectable="isSelectable(date,type)" id="endDate" autocomplete="off"
                                    [min]="toMinDate" [max]="toMaxDate" placeholder="Select To Date"
                                    class="custom-input-border" specialIsAlphaNumeric (click)="openEndDateDatePicker()">
                                <mat-datepicker-toggle matSuffix [for]="endDate" style="color:black;">
                                    <button mat-icon-button>
                                        <mat-icon>event</mat-icon>
                                    </button>
                                </mat-datepicker-toggle>
                                <mat-datepicker #endDate></mat-datepicker>
                            </mat-form-field>
                        </div>

                    </div>
                    <div class="row ">
                        <div class="col-2"></div>
                        <div class="col-xl-4 mt-3">
                            <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'customsssss-mat-field'">
                                <mat-label>Customer Number</mat-label>
                                <input tabindex="3" class="form-control customStyle" matInput appAlphaNumeric
                                    type="text" id="searchText" placeholder="Enter Customer Number"
                                    formControlName="searchText" autocomplete="off" class="col-12" required>
                            </mat-form-field>
                        </div>

                    </div>
                </div>
                <div class="col-xl-1"></div>
            </div>
            <div class="row mt-4  d-flex justify-content-center">
                <div class="col-12 d-flex justify-content-center my-3">
                    <button class="btn reset_btn mr-3" (click)="Reset()">
                        <i class="fa fa-refresh"></i> Reset
                    </button>
                    <button (keydown.enter)="generateInvoice()" (click)="generateInvoice()"
                        class="btn btn-primary mr-3">
                        Generate Statement
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>